<script>
import _ from "lodash";

export default {
  name: "TheScoresCompetitionCard",

  props: {
    achievements: Array,
  },

  computed: {
    sumEducationScores() {
      return this.sumScoresById(8);
    },

    sumResearchScores() {
      return this.sumScoresById(9);
    },

    sumSocialScores() {
      return this.sumScoresById(10);
    },

    sumCultureScores() {
      return this.sumScoresById(11);
    },

    sumSportScores() {
      return this.sumScoresById(12);
    },

    sumAllScores() {
      return _.sumBy(this.achievements, (achievement) =>
        (achievement.subunit?.score || 0) + (achievement.unit?.score || 0));
    },

  },

  methods: {
    sumScoresById(id) {
      return _.sumBy(_.filter(this.achievements, (achievement) => achievement.prtf_achievement_type_id === id),
        (achievement) => (achievement.subunit?.score || 0) + (achievement.unit?.score || 0)
      );
    },
  }
}
</script>

<template>
  <div>
    <v-list class="pa-0">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{sumEducationScores}} бал.</v-list-item-title>
          <v-list-item-subtitle>Учебная <v-icon x-small>fa-book</v-icon></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>{{sumResearchScores}} бал.</v-list-item-title>
          <v-list-item-subtitle>Научная <v-icon x-small>fa-graduation-cap</v-icon></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>{{sumCultureScores}} бал.</v-list-item-title>
          <v-list-item-subtitle>Культорная <v-icon x-small>fa-paint-brush</v-icon> </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list class="pa-0">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{sumSocialScores}} бал.</v-list-item-title>
          <v-list-item-subtitle>Общественная  <v-icon x-small>fa-users</v-icon>  </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>{{ sumSportScores }} бал.</v-list-item-title>
          <v-list-item-subtitle>Спортивная <v-icon x-small>fa-child</v-icon>  </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>{{ sumAllScores }} бал.</v-list-item-title>
          <v-list-item-subtitle class="font-weight-bold">Общий Итог <v-icon x-small>fa-circle</v-icon></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<style scoped>

</style>